import enGB from './en-GB/main';
import zhHK from './zh-HK/main';
import zhCN from './zh-CN/main';
export function t(key, lang) {
    var curLangMain = zhHK;
    if (lang === 'zh-CN') {
        curLangMain = zhCN;
    }
    else if (lang === 'zh-HK') {
        curLangMain = zhHK;
    }
    else {
        curLangMain = enGB;
    }
    return curLangMain[key] || key;
}
